// Auth utilities for handling authentication state

// Save user data to localStorage
const saveAuthData = (token, user) => {
  if (token) {
    localStorage.setItem('token', token);
  }
  if (user) {
    localStorage.setItem('user', JSON.stringify(user));
  }
};

// Clear auth data from localStorage
const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
};

// Check if user is authenticated
const isAuthenticated = () => {
  return !!localStorage.getItem('token');
};

// Get current user data
const getCurrentUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

// Get auth token
const getToken = () => {
  return localStorage.getItem('token');
};

// Check if user has required role
const hasRole = (requiredRole) => {
  const user = getCurrentUser();
  return user && user.roles && user.roles.includes(requiredRole);
};

export {
  saveAuthData,
  clearAuthData,
  isAuthenticated,
  getCurrentUser,
  getToken,
  hasRole
};
